import * as React from "react";

export const SentinelFooter = () => {
  return <></>;
};
